export default "//static.tradera.net/touchweb/static/output/images/category-shoes.482858dd.svg";